import { render, staticRenderFns } from "./SettingsCustomFields.vue?vue&type=template&id=911ea8d2&"
import script from "./SettingsCustomFields.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCustomFields.vue?vue&type=style&index=0&id=911ea8d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports